<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="fb_code,fb_pjcode,pj_dename"
      placeholder="输入单号、项目名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.fb_id"
        :to="'/plm/problem_feedback/' + item.fb_id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.fb_code }}</p>
          <p class="list-item-muted">{{ item.fb_pjcode }}&nbsp;{{ item.fb_pjemname }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.pj_dename }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.fb_status != '已审核' }"
            >{{ item.fb_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}单</label>
    </div>
    <add-button to="/plm/problem_feedback_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/plm/problemfeedback/list",
      filters: [
        {
          type: "date",
          name: "plm_problem_feedback.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "fb_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "fb_status='已审核'",
            }
          ],
        },
      ],
    };
  },
};
</script>